<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title id="title-card">
           <span v-if="itemToDelete.name" class="title">
               {{ $t("administration.delete-vehicle.title") }} "{{ itemToDelete.name }}" ?
           </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <span v-if="errorRequest" class="inputError">{{ $t(errorRequest) }}</span>
        </v-container>
      </v-card-text>
      <v-card-actions id="card-action">
        <baseButton
          id="cancelBtn"
          :value="$t('administration.delete-vehicle.cancel')"
          :action="close"
          white
        />
        <baseButton
          id="okBtn"
          class="okBtn"
          :value="$t('administration.delete-vehicle.ok')"
          :action="deleteItem"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import baseButton from '@/components/base-button.vue'

export default {
  data () {
    return {
      itemToDelete: {
        name: null
      },
      dialog: false,
      errorRequest: null
    }
  },
  components: {
    baseButton
  },
  computed: {
    ...mapGetters('vehicle', ['getFleetId'])
  },
  methods: {
    ...mapActions('vehicle', ['deleteVehicle']),

    display (item) {
      this.itemToDelete = item
      this.dialog = true
    },
    close () {
      this.dialog = false
      this.itemToDelete = {
        name: null
      }
    },
    async deleteItem () {
      const error = await this.deleteVehicle({ fleetID: this.getFleetId, vehicleId: this.itemToDelete.id })
      if (error) {
        switch (error) {
          case 'GENERIC':
            this.errorRequest = 'administration.delete-vehicle.genericError'
            break
          case 'TRANSACTION':
            this.errorRequest = 'administration.delete-vehicle.transactionError'
            break
          case 'ASSUMED':
            this.errorRequest = 'administration.delete-vehicle.assumedVehicleError'
            break
        }
        return
      }
      this.close()
    }
  }
}
</script>

<style>
.title {
  margin-top: 17px;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #10367a;
}

#title-card {
  display: flex;
  justify-content: center;
}

#card-action {
  display: flex;
  justify-content: center;
}

.okBtn {
  margin-left: 48px;
  margin-right: 48px;
  margin-bottom: 30px;
}

#cancelBtn {
  margin-bottom: 30px;
  margin-left: 48px;
}
</style>
